import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { ApiClientError } from "../api";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: any) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      if (err instanceof ApiClientError) setError(err.message);
      else setError("No se pudo iniciar sesión. Verificá tu conexión.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={onSubmit}>
        <div className="brand" style={{ color: "#172a3a", marginBottom: 20 }}>
          MAUVELORE CRM
        </div>
        <label>Email</label>
        <input type="email" value={email} onChange={(e: any) => setEmail(e.target.value)} required autoFocus />
        <label>Contraseña</label>
        <input type="password" value={password} onChange={(e: any) => setPassword(e.target.value)} required />
        {error && <div className="form-error">{error}</div>}
        <button className="btn-primary" type="submit" disabled={loading}>
          {loading ? "Ingresando..." : "Ingresar"}
        </button>
      </form>
    </div>
  );
}
